
import { mapGetters } from "vuex";
import backButtonOutlined from "../common/back-button-outlined.vue";
import MenuDetailHeaderEntryToggler from "./menu-detail-header-entry-toggler.vue";
export default {
  components: {
    backButtonOutlined,
    MenuDetailHeaderEntryToggler
  },
  props: {
    isNew: false
  },
  computed: {
    ...mapGetters("menu", ["syncPendingTotalCount"]),
    menuTitle() {
      return this.$route.path.includes("/combo") ? "Combo" : "Item";
    }
  }
};
